import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EpButtonStyle, EpButtonSize } from '@epicor/kinetic';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';
import { EpbtFaContactsService } from '../../services/epbt-fa-contacts.service';
import { CustomerContact } from 'ep-bt-field-agent-proxy';
import { PageNames, DialogPageNames } from 'ep-bt-controls';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-new-quick-order-customer-details',
  templateUrl: './epbt-fa-new-quick-order-customer-details.component.html',
  styleUrls: ['./epbt-fa-new-quick-order-customer-details.component.scss']
})
export class EpbtFaNewQuickOrderCustomerDetailsComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;
  EpButtonSize = EpButtonSize;
  newOrderCustomerDetailsForm: FormGroup;

  @Output() selectContactSearch = new EventEmitter<any>();
  @Output() selectAddressSearch = new EventEmitter<any>();

  public Profileflag = true;
  public Addressflag = false;
  public Specialflag = false;

  constructor(public quickOrderService: EpbtFaQuickOrderService,
    private formBuilder: FormBuilder,
    private customerService: EpbtFaCustomerService,
    private contactsService: EpbtFaContactsService) { }

  ngOnInit() {
    this.newOrderCustomerDetailsForm = this.formBuilder.group({
      customerRef: [this.quickOrderService.quickOrder.customerRef ? this.quickOrderService.quickOrder.customerRef : ''],
      contactName: [this.quickOrderService.quickOrder.contact ? this.quickOrderService.quickOrder.contact.name : ''], // name
      contact: [this.quickOrderService.quickOrder.contact ? this.quickOrderService.quickOrder.contact.telephone : ''], // telephone
      contactEmail: [this.quickOrderService.quickOrder.contact ? this.quickOrderService.quickOrder.contact.email : '', Validators.email], // email
      deliveryAddress: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.addressCode : ''],
      addressLine1: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.address1 : ''],
      addressLine2: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.address2 : ''],
      addressLine3: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.address3 : ''],
      city: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.city : ''],
      state: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.county : ''],
      zipCode: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.postCode : ''],
      country: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.country : ''],
      specialInstructions: [this.quickOrderService.quickOrder.specialInstructions ? this.quickOrderService.quickOrder.specialInstructions : '']
    });
  }

  customerGroupOnClick(event: any) {
    if (event.index == 0) {
      this.Profileflag = true;
      this.Addressflag = false;
      this.Specialflag = false;
    } else if (event.index == 1) {
      this.Profileflag = false;
      this.Addressflag = true;
      this.Specialflag = false;
    } else if (event.index == 2) {
      this.Profileflag = false;
      this.Addressflag = false;
      this.Specialflag = true;
    }
  }

  // This will be use in html code for validation
  get frmFields() { return this.newOrderCustomerDetailsForm.controls; }

  // Bind the existing values
  bindValuesToForm() {
    this.quickOrderService.quickOrder.customerRef = this.newOrderCustomerDetailsForm.controls['customerRef'].value;
    this.quickOrderService.quickOrder.specialInstructions = this.newOrderCustomerDetailsForm.controls['specialInstructions'].value;

    this.newOrderCustomerDetailsForm.patchValue({
      customerRef: this.quickOrderService.quickOrder.customerRef,
      contactName: this.quickOrderService.quickOrder.contact ? this.quickOrderService.quickOrder.contact.name : '',
      contact: this.quickOrderService.quickOrder.contact ? this.quickOrderService.quickOrder.contact.telephone : '',
      contactEmail: this.quickOrderService.quickOrder.contact ? this.quickOrderService.quickOrder.contact.email : '',
      deliveryAddress: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.addressCode : '',
      addressLine1: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.address1 : '',
      addressLine2: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.address2 : '',
      addressLine3: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.address3 : '',
      city: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.city : '',
      state: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.county : '',
      zipCode: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.postCode : '',
      country: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.country : '',
      specialInstructions: this.quickOrderService.quickOrder.specialInstructions
    });
  }

  // Store the data to respective properties
  storeData() {
    this.quickOrderService.quickOrder.customerRef = this.newOrderCustomerDetailsForm.controls['customerRef'].value;
    if (this.quickOrderService.quickOrder.contact && this.quickOrderService.quickOrder.contact.customerName) {
      this.quickOrderService.quickOrder.contact.telephone = this.newOrderCustomerDetailsForm.controls['contact'].value;
      this.quickOrderService.quickOrder.contact.email = this.newOrderCustomerDetailsForm.controls['contactEmail'].value;
    } else {
      this.quickOrderService.quickOrder.contact = new CustomerContact();
      this.quickOrderService.quickOrder.contact.telephone = this.newOrderCustomerDetailsForm.controls['contact'].value;
      this.quickOrderService.quickOrder.contact.email = this.newOrderCustomerDetailsForm.controls['contactEmail'].value;
    }
    if (this.quickOrderService.quickOrder.deliveryAddress && this.quickOrderService.quickOrder.deliveryAddress.addressCode) {
      this.quickOrderService.quickOrder.deliveryAddress.address1 = this.newOrderCustomerDetailsForm.controls['addressLine1'].value;
      this.quickOrderService.quickOrder.deliveryAddress.address2 = this.newOrderCustomerDetailsForm.controls['addressLine2'].value;
      this.quickOrderService.quickOrder.deliveryAddress.address3 = this.newOrderCustomerDetailsForm.controls['addressLine3'].value;
      this.quickOrderService.quickOrder.deliveryAddress.city = this.newOrderCustomerDetailsForm.controls['city'].value;
      this.quickOrderService.quickOrder.deliveryAddress.county = this.newOrderCustomerDetailsForm.controls['state'].value;
      this.quickOrderService.quickOrder.deliveryAddress.postCode = this.newOrderCustomerDetailsForm.controls['zipCode'].value;
      this.quickOrderService.quickOrder.deliveryAddress.country = this.newOrderCustomerDetailsForm.controls['country'].value;
    }
    this.quickOrderService.quickOrder.specialInstructions = this.newOrderCustomerDetailsForm.controls['specialInstructions'].value;
  }

  onSearchContactClick() {
    this.customerService.fromPage = PageNames.QuickOrder;
    this.contactsService.fromPage = PageNames.QuickOrder;
    this.customerService.selectedCustomer = this.quickOrderService.quickOrder.customer;
    this.selectContactSearch.emit({ dialog: DialogPageNames.ContactsSearch, searchString: '' });
  }

  onSearchAddressClick() {
    this.customerService.fromPage = PageNames.QuickOrder;
    this.customerService.selectedCustomer = this.quickOrderService.quickOrder.customer;
    this.selectAddressSearch.emit({ dialog: DialogPageNames.AddressSearch, searchString: '' });
  }

  public onTabSelect(e) {
    // this.index = e.index;
  }

}
